import type {
  BackendErrorResponse,
  BackendResponse,
  BackendSuccessResponse
} from '@/types/backend-response'
/*
the purpose of this function to handle all success response from the backend
and there are three types of backend response
1- action response: which is the response of POST, PUT and DELETE requests and mostly the response is just {code:200} and there is no data returned 
2- GET response without pagination: mostly the important info returned in response.data.data and the type of data is object
3- GET response with pagination: mostly the data returned in response.data.data and data type is an array and the pagination info returned in response.data.pagination (but not used in this project where no pagination and lists in this project)

function parameter:
response: the full response that received from backend

returned object will contain:
1- isSuccess: always true
2- data: the returned data mostly in POST,PUT and DELETE requests will be null


*/
const success = <T>(response: BackendSuccessResponse<T>): BackendResponse<T> => ({
  isSuccess: true,
  data: response.data.data
})

/*
the purpose of this function to handle all failed response from the backend

there is already an error handler configure in axios interceptors see http-common.js file. 
but i added this handler mainly for 400 errors in order to display each error filed next to the field not just a global error notification 


function parameter:
error: the full error response that received from backend

returned object will contain:
1- isSuccess: always false
2- errorsFields: the array of error fields with their messages 

also default values will returned

*/

const failed = (error: BackendErrorResponse): BackendResponse<never> => ({
  isSuccess: false,
  errorsFields: error.response?.data?.errorsWithMessages || {}
})

export default async function handleCall<T = null>(
  apiCallFunction: () => Promise<BackendSuccessResponse<T>>
): Promise<BackendResponse<T>> {
  try {
    const response = await apiCallFunction()
    return success<T>(response)
  } catch (error) {
    return failed(error as BackendErrorResponse)
  }
}
